import { render } from "./DonationForm.vue?vue&type=template&id=924bb6d2&scoped=true"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"

import "./DonationForm.vue?vue&type=style&index=0&id=924bb6d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924bb6d2"]])

export default __exports__